// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1ZcpB","image":"Header_image__10e_2","name":"Header_name__1HDHx","info":"Header_info__1HYX6","infoRow":"Header_infoRow__W1W1J"};